import { loadNewsList, loadNewsContent, loadPolicyContent } from '../../../fetch/news'

const types = {
  LOAD_NEWS_LIST: 'LOAD_NEWS_LIST',
  LOAD_NEWS_CONTENT: 'LOAD_NEWS_CONTENT',
  LOAD_POLICY_CONTENT: 'LOAD_POLICY_CONTENT'
}
const news = {
  state: {
    [types.LOAD_NEWS_LIST]: null,
    [types.LOAD_NEWS_CONTENT]: null,
    [types.LOAD_POLICY_CONTENT]: null
  },
  actions: {
    [types.LOAD_NEWS_LIST]: async ({ commit }, pages) => {
      const res = await loadNewsList(pages)
      return commit(types.LOAD_NEWS_LIST, res)
    },
    [types.LOAD_NEWS_CONTENT]: async ({ commit }, id) => {
      const res = await loadNewsContent(id)
      return commit(types.LOAD_NEWS_CONTENT, res)
    },
    [types.LOAD_POLICY_CONTENT]: async ({ commit }, id) => {
      const res = await loadPolicyContent(id)
      return commit(types.LOAD_POLICY_CONTENT, res)
    }
  },
  mutations: {
    [types.LOAD_NEWS_LIST]: (state, res) => (state[types.LOAD_NEWS_LIST] = res),
    [types.LOAD_NEWS_CONTENT]: (state, res) =>
      (state[types.LOAD_NEWS_CONTENT] = res),
    [types.LOAD_POLICY_CONTENT]: (state, res) =>
      (state[types.LOAD_POLICY_CONTENT] = res)
  },
  getters: {
    getLoadNewsList (state) {
      return state[types.LOAD_NEWS_LIST]
    },
    getLoadNewsContent (state) {
      return state[types.LOAD_NEWS_CONTENT]
    },
    getloadPolicyContent (state) {
      return state[types.LOAD_POLICY_CONTENT]
    }
  }
}
export default news
